<template>
  <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px" class="app-container view-container">
    <BjDivider>
      {{ $t('BusinessAfterCsgReturn.damageTitleText') }}
      <template slot="right">
          <el-button @click="cancel()">{{ $t('backText') }}</el-button>
          <el-button @click="tryCancel()">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('okText') }}</el-button>
        </template>
    </BjDivider>
    <template>
      <el-row :gutter="10">
      <el-row>
      <el-col :span="colSpan">
        <el-form-item :label="$t('BusinessAfterCsgReturn.main.totalQty')">
          <BjInput v-model="form.planQty" disabled type="text" autosize :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderDetail.table.associatedCode')">
             <BjInput v-model="form.thirdCode" type="text" disabled :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('BusinessAfterCsgReturn.table.reference')">
           <BjInput v-model="form.remark" disabled type="textarea" show-word-limit autosize :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('BusinessAfterCsgReturn.main.orderStatus')" prop="status">
          <BjSelectLov v-model="form.status" :option-list="RETURN_ORDER_STATUS" />
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
      <el-col :span="3">
        <el-form-item :label="$t('BusinessAfterCsgReturn.main.backInventoryQty')" prop="backInventoryQty">
          <BjInputNumber v-model="form.backInventoryQty" class="full-width" clearable :controls="false" />
        </el-form-item>
      </el-col>
      <el-col :span="9">
        <el-form-item :label="$t('BusinessAfterCsgReturn.main.backInventoryRemark')">
          <BjInput v-model="form.backInventoryRemark" type="textarea" show-word-limit autosize :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$t('BusinessAfterCsgReturn.main.damagedQty')" prop="damagedQty">
          <BjInputNumber v-model="form.damagedQty" class="full-width" clearable :controls="false" />
        </el-form-item>
      </el-col>
      <el-col :span="9">
        <el-form-item :label="$t('BusinessAfterCsgReturn.main.damagedRemark')">
          <BjInput v-model="form.damagedRemark" type="textarea" show-word-limit autosize :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
      </el-row>
    </el-row>
  </template>

      <BjDivider
        >{{ $t('AddingAnInternalReturnRefundDoc.Product') }}
      </BjDivider>
      <div class="bj-col bj-col-24" style="border-left:none">
        <el-table :data="[form]" border script max-height="600px">
          <el-table-column prop="standardSkuCode" label="SKU" align="center" />
          <el-table-column prop="barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" align="center" />
          <el-table-column prop="planQty" :label="$t('goodsSku.detail.qty')" align="center" />
          <el-table-column prop="skuStatus" :label="$t('BusinessAfterCsgReturn.table.skuStatus')" align="center"><template>{{ $t(RETURN_PRODUCT_STATUS.bjGet(form.skuStatus)) }}</template></el-table-column>
        </el-table>
      </div>

  <BjDivider>{{ $t('BusinessAfterCsgReturn.pictureMsg') }}</BjDivider>
    <div class="mt20">
      <div class="flex">
            <div v-for="(imageUrl, index) in form.thirdPartyReturnOrderMaterialList" :key="index" class="imageViewer">
              <BjKeyImage
                height="148px"
                width="148px"
                :url="imageUrl.detailImage"
                style="margin: 10px"
                preview
              />
              <div class="flex flex-spacearound">
                <i class="el-icon-download yellow" @click="downloadImage(imageUrl.detailImage)"></i>
                <i class="el-icon-delete red" @click="deleteImage(imageUrl.detailImage)"></i>
              </div>
            </div>
          </div>
    </div>

    <BjDivider>{{ $t('InternalReturnRefundNoteDetails.Upload') }}{{ $t('AddingAnInternalReturnRefundDoc.Picture') }}</BjDivider>
    <div class="mt20">
      <el-form-item label="" style="display: block; height: 100%">
        <BjUpload
          ref="BjUpload"
          class="avatar-uploader"
          :limit="20"
          :limit-size="5 * 1024"
          multiple
          show-file-list
          list-type="picture-card"
          accept="image/png,image/jpeg"
          :accept-list="['image/jpeg', 'image/png']"
          auto-upload
          limit-hide
          @afterUpload="afterUpload"
          @remove="onRemoveUrl"
        >
          <template slot="default">
            <i class="el-icon-plus avatar-uploader-icon" />
          </template>
          <template slot="tip">
          </template>
        </BjUpload>
      </el-form-item>
    </div>
  </el-form>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import BjInputNumber from '@/packages/BjInputNumber';
import { thirdReturnApi } from '@/api';
import {RETURN_ORDER_STATUS, RETURN_PRODUCT_STATUS} from '@/utils/constants';
import BjUpload from '@/components/BjUpload/index';
export default {
name: 'BusinessAfterCsgReturnEdit',
components: {
  BjUpload,
  BjInputNumber
},
mixins: [viewMiXin],
data() {
  return {
    RETURN_ORDER_STATUS,
    RETURN_PRODUCT_STATUS,
    colSpan: 8,
    form: {},
    updateImages: [], // 存放临时上传的图片

    rules: {
      'backInventoryQty': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      'damagedQty': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      'status': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
    },
  };
},
computed: {
},
mounted() {
  this.getData();
},
methods: {
  // 删除图片
  deleteImage(file) {
    this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
      this.form.thirdPartyReturnOrderMaterialList.splice(
        this.form.thirdPartyReturnOrderMaterialList.findIndex(e => e.detailImage === file),
        1,
      );
      this.form.thirdPartyReturnOrderMaterialList = this.form.thirdPartyReturnOrderMaterialList.map(item => {
        return {detailImage: item.detailImage};
      });
      setTimeout(() => {
        this.editApi(this.form);
      }, 300);
    }).catch(_ => {});
  },
  // 截取下载的图片名
  imageFileName(url) {
    const urlObj = new URL(url);
    // 获取路径名部分（包括查询参数和哈希值之前的部分）
    const pathname = urlObj.pathname;
    // 使用最后一个'/'字符将路径名分割成目录和文件名两部分
    const parts = pathname.split('/');
    // 提取出文件名
    const fileName = parts.pop();
    // 如果文件名包含查询参数或哈希值，使用'?'或'#'字符将其分割出来
    const fileNameWithoutQueryOrHash = fileName.split('?')[0].split('#')[0];
    return fileNameWithoutQueryOrHash;
  },
  // 下载图片
  downloadImage(url) {
    if (!url) return;
    url = this.normalizeDownloadUrl(url);
    const fileName = this.imageFileName(url);
    this.downloadImageUrl(url, fileName);
  },
  // 获取 上传的 新数据 并 合并到旧数据
  afterUpload(url) {
    this.updateImages.push({detailImage: url});
  },
  onRemoveUrl(file) {
    this.updateImages.splice(
        this.updateImages.findIndex(e => e.detailImage === file.url),
        1,
      );
  },
  /** 确定 */
  onConfirm() {
    this.$refs.form.validate(valid => {
      if (!valid) return this.$scrollToFormError();
      if ((this.form.backInventoryQty + this.form.damagedQty) !== this.form.planQty) return this.$message.error(this.$t('BusinessAfterCsgReturn.hintMessageText5'));
      if (this.updateImages.length) {
        this.form.thirdPartyReturnOrderMaterialList = this.form.thirdPartyReturnOrderMaterialList.map(item => {
          return {detailImage: item.detailImage};
        });
        this.updateImages.forEach(item => this.form.thirdPartyReturnOrderMaterialList.push(item));
      }
      this.editApi(this.form);
    });
  },

  editApi(API_DATA) {
    delete API_DATA.createdBy;
    delete API_DATA.lastUpdatedBy;
    thirdReturnApi.editThirdPartyReturnOrder(API_DATA).then(res => {
      if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
        this.$message.success(this.$t('toast.operationSuccessText'));
        setTimeout(() => {
          this.getData();
          this.$refs.BjUpload.fileList = [];
          this.updateImages = [];
        }, 500);
      }
    });
  },
  getData() {
    thirdReturnApi.detailThirdPartyReturnOrder({orderId: this.$route.query.id}).then(res => {
      this.form = res;
    });
  }
},
};
</script>
<style lang="scss" scoped>
.app-container {

  .imageViewer {
    display: flex;
    flex-direction: column;
    align-items: center;

    .red {
      color: red;
      cursor: pointer;
    }
    .yellow {
      color: #ff8f40;
      cursor: pointer;
      font-size: 18px;
    }
  }
}

</style>
